import React, { useState } from 'react'
import { Tabs } from 'antd'
import { Route, useLocation } from 'react-router-dom'
import { Switch } from 'react-router-dom'
import { SinglePanel } from '@/components/common/panel'
import { WrappedRouteNotFound } from '@/components/common/route-not-found'
import { useGlobalContext } from '@/components/context'
import history from '@/utils/history'
import { useTitle } from '@/utils/hooks'
import { pharosAdminLlmChatQueueUrl, pharosAdminSwitchOrgUrl } from '@/utils/url'
import { LlmChatQueue } from './llm-chat-queue'
import { SwitchOrg } from './switch-org'

const TABS = [
	{ key: pharosAdminSwitchOrgUrl(), label: 'Switch Org', component: SwitchOrg },
	{ key: pharosAdminLlmChatQueueUrl(), label: 'LLM Chat Queue', component: LlmChatQueue },
]

export const AdminPanel = () => {
	useTitle('Account Settings')
	const location = useLocation()

	const globalContext = useGlobalContext()
	if (!globalContext.user.isAdmin) {
		return <div>You are not admin</div>
	}

	const activeKey = TABS.find((t) => location.pathname.startsWith(t.key))?.key ?? TABS[0].key

	return (
		<SinglePanel>
			<Tabs activeKey={activeKey} items={TABS} onChange={(key) => history.push(key)} />
			<Switch>
				{TABS.map((tab) => (
					<Route key={tab.key} path={tab.key} component={tab.component} />
				))}
				<Route path="*" component={WrappedRouteNotFound} />
			</Switch>
		</SinglePanel>
	)
}
